/** Not every org has missions, so the copy names what everyone has. */
export const SEARCH_PLACEHOLDER = 'Search for a map, location or datasets';
